import { useEffect } from 'react';

interface UseKeyboardProps {
  onRefresh?: () => void;
  onShare?: () => void;
  enabled?: boolean;
}

export const useKeyboard = ({ onRefresh, onShare, enabled = true }: UseKeyboardProps) => {
  useEffect(() => {
    if (!enabled) return;

    const handleKeyPress = (event: KeyboardEvent) => {
      // 忽略在输入框中的按键
      const target = event.target as HTMLElement;
      if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
        return;
      }

      switch (event.key.toLowerCase()) {
        case 'r':
          event.preventDefault();
          onRefresh?.();
          break;
        case 's':
          event.preventDefault();
          onShare?.();
          break;
      }
    };

    document.addEventListener('keydown', handleKeyPress);

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [onRefresh, onShare, enabled]);
};